export default "__VITE_ASSET__D3nwWQX6__"